<template>
	<div>
		<Select
			class="mt-4 lancar-notas-header-select"
			label="Mês"
			v-model="mes"
			:options="meses"
			@change="reload"/>

		<v-card class="pa-3">
			<v-flex xs12>
				<table class="table-siged mt-3" v-if="colunas.length > 0">
				<thead>
					<tr>
						<th colspan="1"></th>
						<th :colspan="colunas.length">DIAS</th>
					</tr>
					<tr>
					<!-- 	<th style="width: 10%">Foto</th> -->
						<th style="width: 50%">Aluno</th>
						<th v-for="(data) in colunas" :key="data.id">
							{{data.dia}}
							<div >
								<v-tooltip right color="rgba(96, 184, 99, 0.9)">
									<template v-slot:activator="{ on }">
										<v-btn icon color="green" @click="marcarTodos(data.dia)" v-on="on" :disabled="loading">
											<v-icon>playlist_add_check</v-icon>
										</v-btn>
									</template>
									<span>Marcar Todos</span>
								</v-tooltip>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr  v-for="(enturmacao) in alunos" :key="enturmacao.id">
						<!-- <td class="centro">foto</td> -->
						<td>{{enturmacao.nmaluno}}</td>
						<td v-for="(key, index) in colunas" :key="key.id" class="centro">
							<div v-if="verificarDataEnturmacao(enturmacao.dtsitalun, enturmacao.aulas[index].dataaula)">NÃO ESTAVA NA TURMA</div><!-- Quando a data da enturmação for maior que a data da aula -->
							<div v-else-if="enturmacao.invalido">{{ enturmacao.invalido }}</div>
							<div v-else>
								<CheckFrequencia
									:disabled="loading || verificarDataEnturmacao(enturmacao.dtsitalun, enturmacao.aulas[index].dataaula)"
									v-model="enturmacao.aulas[index].frequencia"
									@click="submit(key,enturmacao.numatalun,enturmacao.turma,enturmacao.aulas[index].frequencia)"
								/>
							</div>
						</td>
					</tr>
				</tbody>
				</table>
				<p v-else >
					Não possuem aula(s) cadastradas para esse mês.
				</p>
			</v-flex>
		</v-card>
	<v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
  </v-snackbar>
	</div>
</template>

<script>
import store from '@/store/index';
import CheckFrequencia from '@/components/CheckFrequencia';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import udias from '@/utils/dias';
import moment from 'moment';
import _ from 'lodash';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

moment.locale('pt-br');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

export default {
	name: 'FrequenciaMensal',
	components: {
    CheckFrequencia,
  },
	props: {
		ano: Number,
		disciplina: Number,
		cdturma: String,
	},
	data(){
		return {
			mes: moment().format('M'),
			dados: [],
			frequencia: [],
			submitText: '',
			snackbar: false,
			loading: false,
			inv:false,
		}
	},
	created() {
		this.reload();
	},
	mounted() {
		this.$Progress.finish();
	},
	methods: {
		async reload(){
			this.$Progress.start();
			const { data } = await DiarioEscolarRepository.getListarAulasMes({
				...dadosUser(),
				mes: this.mes,
				aaletivo: this.ano,
				cddiscipl: this.disciplina,
				cdturma: this.cdturma,
			});
			this.dados = data.results;
			this.$Progress.finish();
		},
		async submit(aulas,numatalun,turma,frequencia){
			try{
			this.$Progress.start();
			this.loading = true;
			const formulario = {
				identificadoraula: aulas.codigoaulas,
        cdtipesc: turma.cdtipesc,
        cdescola: turma.cdescola,
				alunos: [{
					numatalun : numatalun,
					indicapresenca: frequencia,
				}]
			};

			const { data } = await DiarioEscolarRepository.setFrequancia(formulario);

			this.submitText = data.message;
			this.snackbar = true;
			}finally{
				this.$Progress.finish();
				this.loading = false;
			}

		},
		verificarSituacao(situacao){
      if(typeof situacao === 'undefined' || situacao === null) { return false; }
      return this.situacaoFim.indexOf(parseInt(situacao.cdsitalun)) >= 0;
    },
    verificarDataEnturmacao(dataEnturmacao, dataaula){
      return (dataEnturmacao > dataaula);
		},
		async marcarTodos(dia){
			try{
				this.$Progress.start();
				this.loading = true;
				const formulario = {
					identificadoraula: [],
					cdtipesc: '',
					cdescola: '',
					alunos: []
				};
				this.dados = this.dados.map(key => {
					if(!(key.invalido)) {
						for (const index in key.aulas){
							if(key.aulas[index].dia == dia && !(this.verificarDataEnturmacao(key.dtsitalun, key.aulas[index].dataaula))){
								key.aulas[index].frequencia = 'P';

								formulario.identificadoraula = key.aulas[index].codigoaulas;
								formulario.cdtipesc = key.turma.cdtipesc;
								formulario.cdescola = key.turma.cdescola;
								formulario.alunos.push({
									numatalun : key.numatalun,
									indicapresenca: 'P',
								});
							}
						}
					}
					return key;
				});

				const { data } = await DiarioEscolarRepository.setFrequancia(formulario);

				this.submitText = data.message;
				this.snackbar = true;

			}finally{
				this.$Progress.finish();
				this.loading = false;
			}
    },
	},
	computed: {
		meses(){
			var meses = udias.meses.map((v, i) => ({
				value: i + 1,
				text: v,
			}));

			return _.remove(meses, function(n){
				return n.value <= moment().format('M');
			});

		},
		colunas(){
			if(this.dados.length > 0)
				return this.dados[0].aulas;
			else
				return 0;
		},
		alunos(){
			return this.dados;
		}
	},

}
</script>

<style lang="sass" scoped>

</style>
